import {
    Dimensions,
    Platform,
    StatusBar,
    StyleSheet,
    ViewStyle,
} from 'react-native';

import { Fonts } from 'assets/fonts';

import { WEB_SUBTITLES_FULLSCREEN_PLAYER_FONT_SIZE } from 'config/constants.ts';

import { COLOR } from 'utils/colors';
import {
    dimensionsToAspectRatio,
    isTablet,
    landscapeAspectRatio,
} from 'utils/responsiveness';

const { width, height } = Dimensions.get('screen');

const screenWidth = Math.max(width, height);
const screenHeight = Math.min(width, height);
const screenAspectRatio = dimensionsToAspectRatio(screenWidth, screenHeight);

const styles = StyleSheet.create({
    modal: { margin: 0 },
    container: {
        flex: 1,
        backgroundColor: COLOR.BLACK,
        zIndex: 1,
    },
    safeArea: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    player: {
        alignSelf: 'center',
        ...Platform.select<ViewStyle>({
            web: {
                height: '100%',
                // @ts-ignore
                fontFamily: Fonts.main.regular,
                fontSize: WEB_SUBTITLES_FULLSCREEN_PLAYER_FONT_SIZE,
            },
            default: isTablet
                ? {
                      width: screenWidth,
                  }
                : {
                      height: screenHeight,
                  },
        }),
        aspectRatio: Platform.select({
            web: dimensionsToAspectRatio(width, height),
            default: screenAspectRatio,
        }),
    },
    fitPlayer: {
        alignSelf: 'center',
        ...Platform.select<ViewStyle>({
            web: {
                // @ts-ignore
                fontFamily: Fonts.main.regular,
                fontSize: WEB_SUBTITLES_FULLSCREEN_PLAYER_FONT_SIZE,
            },
            default: isTablet
                ? {
                      height:
                          (StatusBar.currentHeight || 0) * 2 +
                          screenHeight +
                          screenHeight -
                          screenWidth / landscapeAspectRatio +
                          // Random additional value because player view is not stretching full height, simple View is stretching correctly, but player - no
                          Platform.select({ ios: 60, default: 0 }),
                  }
                : {
                      width:
                          (StatusBar.currentHeight || 0) * 2 +
                          screenWidth +
                          screenWidth -
                          landscapeAspectRatio * screenHeight +
                          // Random additional value because player view is not stretching full height, simple View is stretching correctly, but player - no
                          Platform.select({ ios: 32, default: 0 }),
                  },
        }),
        aspectRatio: screenAspectRatio,
    },
});

export default styles;
